// models/produtos/UnMedida.js
export class UnMedida {
    constructor(sigla = '', descricao = '') {
        this.sigla = sigla;
        this.descricao = descricao;
    }
}